import { useSelector, useDispatch } from 'react-redux';
import { Button, Badge, Flex, Divider } from '@chakra-ui/react';
import deepEqual from 'fast-deep-equal/es6/react';
import { ApplicationState } from '@/store/index';
import { setSelectedRows, selectAll } from '@/store/dashboard/actions';
import { MoveTo } from './MoveTo';
import { MoreActions } from './MoreActions/index';
import { EditTags } from './EditTags';
import { ExportAllButton } from '@/components/atoms/ExportAllButton/ExportAllButton';
import { hasPerm, P } from '@/utilities/roles/permissions';

export const SelectedActions = () => {
  const dispatch = useDispatch();
  const userRole = useSelector(({ auth }: ApplicationState) => auth.role);
  const allSelected = useSelector(({ dashboard }: ApplicationState) => dashboard.allSelected);
  const canEditTags = hasPerm(userRole, P.EDIT_TAGS);
  const canEditStudentStatus = hasPerm(userRole, P.STUDENT_STATUS_EDIT);
  const canViewActionDropdown = hasPerm(userRole, P.VIEW_ACTION_DROPDOWN);
  const { selectedCount, stageTotal } = useSelector(({ dashboard }: ApplicationState) => {
    const activeTab = dashboard.tabs.find(tab => (tab as any).active);
    const stageTotal = dashboard.totals?.find(total => total.casStatus === activeTab?.id)?.total ?? 0;
    return {
      selectedRows: dashboard.selectedRows,
      selectedCount: Object.keys(dashboard.selectedRows).length,
      stageTotal,
    };
  }, deepEqual);

  const CustomDivider = () => {
    return <Divider orientation="vertical" mx={3} opacity={1} borderLeftWidth={'2px'} height={4} />;
  };

  return (
    <Flex
      bgColor={'selected-bg'}
      borderColor={'selected-border'}
      alignItems={'center'}
      height={12}
      width={'100%'}
      my={1}
      px={3}
      borderRadius={'lg'}
      borderWidth={1}
      overflowY={'auto'}
      className="nav-scrollbar"
    >
      <Badge size={'md'} minWidth={5} variant="vivid-pill" colorScheme="blue">
        {allSelected ? stageTotal : selectedCount}
      </Badge>

      <Button
        data-selector="select-all"
        size="sm"
        variant="ghost"
        onClick={() => {
          if (allSelected) {
            dispatch(setSelectedRows([]));
            dispatch(selectAll(false));
          } else {
            dispatch(selectAll(true));
          }
        }}
      >
        {allSelected ? 'Deselect all' : 'Select all'}

        {!allSelected ? (
          <Badge variant="pill" size="xs" ml={2}>
            {stageTotal}
          </Badge>
        ) : null}
      </Button>

      {canEditStudentStatus && (
        <>
          <CustomDivider />
          <MoveTo />
        </>
      )}

      <CustomDivider />

      {canEditTags && <EditTags />}

      <ExportAllButton />

      {canViewActionDropdown && (
        <>
          <CustomDivider />
          <MoreActions />
        </>
      )}
    </Flex>
  );
};
